/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import { setPagination } from "./../../utils/helpers/pagination";

export default {
  SET_USERS_WITH_PAGINATION(state, data) {
    state.users = data.data || [];
    state.pagination = data.pagination || {};
  },
  SET_USERS(state, data) {
    state.users = data || [];
  },
  SET_PAGINATION(state, data) {
    state.pagination = { ...state.pagination, ...data };
  },
  SET_USER(state, user) {
    state.user = user;
  },
  ADD_USER(state, user) {
    state.users.push(user);
  },
  UPDATE_USER(state, user) {
    console.log(user);
    const userIndex = state.users.findIndex((u) => u.id === user.id);
    if (userIndex >= 0) Object.assign(state.users[userIndex], user);
  },
  REMOVE_RECORD(state, itemId) {
    if (Array.isArray(itemId)) {
      itemId.forEach((item) => {
        const userIndex = state.users.findIndex((u) => u.id === item);
        state.users.splice(userIndex, 1);
      });
    } else {
      const userIndex = state.users.findIndex((u) => u.id === itemId);
      state.users.splice(userIndex, 1);
    }

    state.pagination = setPagination(state.pagination, itemId);
  },
};
